module.exports = __webpack_public_path__ + "static/media/verified-check.24460d3b.svg";